(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("4kPjv", function(module, exports) {

var $dQWmF = parcelRequire("dQWmF");
const $3280d582f8513044$var$serviceSectionFilters = document.querySelectorAll(".f-service");
$3280d582f8513044$var$serviceSectionFilters.forEach((filter)=>{
    filter?.addEventListener("beforeFetch", ()=>{
        (0, $dQWmF.pushToDataLayer)("click_filter");
    });
});

});
parcelRegister("dQWmF", function(module, exports) {

$parcel$export(module.exports, "pushToDataLayer", function () { return $a15d67afa38252c7$export$3c27964bdf7ca185; });
const $a15d67afa38252c7$export$3c27964bdf7ca185 = (eventName, options = {})=>{
    window.dataLayer = window.dataLayer || [];
    if (eventName) window.dataLayer.push({
        event: eventName,
        ...options
    });
    else window.dataLayer.push({
        ...options
    });
};

});


})();
//# sourceMappingURL=service-section.c3bfc2e4.js.map
